import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceAccount',
})
export class ReplaceAccountPipe implements PipeTransform {
  transform(value: any): any {
    let textFinal = '';
    const valueSting = value.toString();
    const reg = new RegExp('^[0-9]*$', 'g');
    const texEncrypt = valueSting.substring(0, valueSting.length - 3);
    for (let i = 0; i < texEncrypt.length; i++) {
      textFinal = textFinal + texEncrypt.charAt(i).replace(reg, '*');
    }
    const text = valueSting.substring(valueSting.length - 3, valueSting.length);

    return textFinal + text;
  }
}
